import "./style.scss"
import { ListHeaderCell, ListHeaderCellType } from "views/components/atoms/listCell";

export type ListHeaderType = {
  type : ListHeaderCellType;
  label? : string;
}

type ListHeaderProps = {
  headerShowList : ListHeaderType[];
}

export const ListHeader = (props:ListHeaderProps) => {
    const { headerShowList } = props;
    return (
        <div className="listHeader">
          {
            headerShowList.map((item, i) => {
              return (
                <ListHeaderCell key={i} type={item.type} label={item.label} />
              )
            })
          }
        </div>
    )
}